import React, { useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'

import { notify } from 'helpers/helpers'
import { httpOk, GET, POST, DELETE } from 'helpers/api'
import { hasPermission } from 'helpers/permissions'
import DeleteModal from 'pages/parts/DeleteModal'

// Приложения гостей по брендам: ключ Firebase и тестовый push.
// У каждого бренда свой проект Firebase (приложение выпущено с аккаунта заведения),
// поэтому без загруженного ключа сервер не может отправить гостю ни одного уведомления,
// а приложение прячет переключатель push (config → push.enabled = false).
const RELEASE_STATUSES = {
	0: 'Черновик',
	1: 'Заявка',
	2: 'Сборка',
	3: 'В сторе',
	4: 'Снято',
}

const emptyTest = { mobile_app_id: null, phone: '', title: '', body: '' }

const emptyBuild = {
	mobile_app_id: null,
	android_package: '',
	ios_bundle_id: '',
	android_store_url: '',
	ios_store_url: '',
	min_supported_build_android: '',
	min_supported_build_ios: '',
	latest_build_android: '',
	latest_build_ios: '',
	review_phone: '',
	review_otp: '',
	release_status: 0,
}

function formatDate(value) {
	if (!value) return ''
	return String(value).slice(0, 16).replace('T', ' ')
}

function Index() {
	const canManage = hasPermission('admin_mobile_apps_manage')

	const [data, setData] = useState([])
	const [search, setSearch] = useState('')

	const [keyModal, setKeyModal] = useState(false)
	const [selectedApp, setSelectedApp] = useState(null)
	const [credentials, setCredentials] = useState('')
	const fileRef = useRef(null)

	const [deleteModal, setDeleteModal] = useState(false)

	const [testModal, setTestModal] = useState(false)
	const [testItem, setTestItem] = useState(emptyTest)
	const [testResult, setTestResult] = useState(null)

	const [buildModal, setBuildModal] = useState(false)
	const [buildItem, setBuildItem] = useState(emptyBuild)

	async function getData() {
		const response = await GET('/admin/mobile-apps', search ? { 'search': search } : {}, { loader: true })
		if (httpOk(response)) setData(response.data.data || [])
	}

	function openBuildModal(item) {
		setSelectedApp(item)
		// null приходит с бэкенда у незаполненных полей — в инпуте это должна быть пустая строка
		setBuildItem({
			'mobile_app_id': item.id,
			'android_package': item.android_package ?? '',
			'ios_bundle_id': item.ios_bundle_id ?? '',
			'android_store_url': item.android_store_url ?? '',
			'ios_store_url': item.ios_store_url ?? '',
			'min_supported_build_android': item.min_supported_build_android ?? '',
			'min_supported_build_ios': item.min_supported_build_ios ?? '',
			'latest_build_android': item.latest_build_android ?? '',
			'latest_build_ios': item.latest_build_ios ?? '',
			'review_phone': item.review_phone ?? '',
			'review_otp': item.review_otp ?? '',
			'release_status': item.release_status ?? 0,
		})
		setBuildModal(true)
	}

	// Публичная страница удаления аккаунта гостя — её адрес бренд вписывает в Google Play
	function deletionUrl(app) {
		return `https://cabinet.mison.uz/delete-account/${app.uuid}`
	}

	async function copyDeletionUrl(app) {
		try {
			await navigator.clipboard.writeText(deletionUrl(app))
			notify('Ссылка скопирована', 'success')
		} catch (e) {
			notify('Не удалось скопировать — выделите ссылку вручную')
		}
	}

	async function saveBuild(e) {
		e.preventDefault()

		const response = await POST('/admin/mobile-apps/build', buildItem, { loader: true })

		if (httpOk(response)) {
			notify('Сохранено', 'success')
			setBuildModal(false)
			getData()
		}
	}

	function openKeyModal(item) {
		setSelectedApp(item)
		setCredentials('')
		setKeyModal(true)
	}

	function readFile(e) {
		const file = e.target.files?.[0]
		if (!file) return
		const reader = new FileReader()
		reader.onload = () => setCredentials(String(reader.result || ''))
		reader.readAsText(file)
		e.target.value = ''
	}

	async function saveKey(e) {
		e.preventDefault()
		if (!credentials.trim()) {
			notify('Выберите файл ключа или вставьте его содержимое')
			return
		}

		const response = await POST('/admin/mobile-apps/push-key', {
			'mobile_app_id': selectedApp.id,
			'credentials': credentials.trim(),
		}, { loader: true })

		if (httpOk(response)) {
			notify('Ключ проверен в Google и сохранён', 'success')
			setKeyModal(false)
			getData()
		}
	}

	function openDeleteModal(item) {
		setSelectedApp(item)
		setDeleteModal(true)
	}

	async function deleteKey() {
		const response = await DELETE(`/admin/mobile-apps/${selectedApp.id}/push-key`, {}, { loader: true })
		if (httpOk(response)) {
			setDeleteModal(false)
			getData()
		}
	}

	function openTestModal(item) {
		setSelectedApp(item)
		setTestItem({ ...emptyTest, mobile_app_id: item.id })
		setTestResult(null)
		setTestModal(true)
	}

	async function sendTest(e) {
		e.preventDefault()
		setTestResult(null)

		const response = await POST('/admin/mobile-apps/test-push', testItem, { loader: true })
		if (httpOk(response)) {
			setTestResult(response.data.data)
			getData()
		}
	}

	useEffect(() => {
		getData()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between align-items-center">
				<div>
					<h4 className="vertical-center mb-1">Мобильные приложения [{data.length}]</h4>
					<p className="text-muted mb-0 fz-14">
						Ключ Firebase бренда нужен для push гостям: статусы заказа, начисление баллов.
						Без него приложение не показывает переключатель уведомлений.
					</p>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<form className="d-flex gap-2 mb-3" onSubmit={(e) => { e.preventDefault(); getData() }}>
						<input type="text" className="form-control" style={{ 'maxWidth': 320 }}
							placeholder="Логин или название бренда"
							value={search}
							onChange={(e) => setSearch(e.target.value)} />
						<button type="submit" className="btn btn-primary">Найти</button>
					</form>

					<div className="table-responsive">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ 'width': '18%' }}>Бренд</th>
									<th style={{ 'width': '20%' }}>Сборки</th>
									<th style={{ 'width': '10%' }} className="text-center">Выпуск</th>
									<th style={{ 'width': '20%' }} className="text-center">Ключ Firebase</th>
									<th style={{ 'width': '12%' }} className="text-center">Устройства</th>
									<th style={{ 'width': '20%' }} className="text-center"></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item) => (
									<tr key={item.id}>
										<td>
											<div className="fw-semibold">{item.brand_name || item.name || item.login}</div>
											<div className="text-muted fz-12">{item.login}</div>
										</td>
										<td className="fz-13">
											<div><i className="uil-android me-1" />{item.android_package || <span className="text-muted">не задан</span>}</div>
											<div><i className="uil-apple me-1" />{item.ios_bundle_id || <span className="text-muted">не задан</span>}</div>
										</td>
										<td className="text-center">{RELEASE_STATUSES[item.release_status] ?? item.release_status}</td>
										<td className={`text-center ${item.has_push_key || item.default_firebase_project_id ? 'bg-success text-white' : 'bg-danger text-white'}`}>
											{item.has_push_key
												? <>
													<div>{item.firebase_project_id}</div>
													<div className="fz-12">свой, загружен {formatDate(item.push_key_updated_at)}</div>
												</>
												: item.default_firebase_project_id
													? <>
														<div>{item.default_firebase_project_id}</div>
														<div className="fz-12">общий ключ Mison</div>
													</>
													: 'Не загружен'
											}
										</td>
										<td className="text-center">
											<div>Android: {item.devices_android}</div>
											<div>iOS: {item.devices_ios}</div>
										</td>
										<td className="text-center">
											{canManage &&
												<div className="d-flex justify-content-center gap-2 flex-wrap">
													<button className="btn btn-sm btn-outline-secondary" title="Сборка и выпуск" onClick={() => openBuildModal(item)}>
														<i className="uil-cog" />
													</button>
													<button className="btn btn-sm btn-outline-dark" title="Загрузить ключ" onClick={() => openKeyModal(item)}>
														<i className="uil-key-skeleton me-1" />
														{item.has_push_key ? 'Заменить' : 'Загрузить'}
													</button>
													{(item.has_push_key || item.default_firebase_project_id) &&
														<button className="btn btn-sm btn-outline-primary" title="Тестовый push" onClick={() => openTestModal(item)}>
															<i className="uil-bell" />
														</button>
													}
													{item.has_push_key &&
														<>
															<button className="btn btn-sm btn-outline-danger" title="Удалить ключ" onClick={() => openDeleteModal(item)}>
																<i className="uil-trash-alt" />
															</button>
														</>
													}
												</div>
											}
										</td>
									</tr>
								))}
								{data.length === 0 &&
									<tr><td colSpan="6" className="text-center text-muted">Список пуст</td></tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<Modal show={buildModal} animation={false} centered size="lg" onHide={() => setBuildModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Сборка и выпуск — {selectedApp?.brand_name || selectedApp?.login}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={saveBuild} autoComplete="off">
						<div className="alert alert-warning fz-14">
							Package и bundle id берутся из <span className="font-monospace">brands/&lt;бренд&gt;/brand.json</span> шаблона.
							У выпущенного приложения менять их нельзя: установленные сборки отвяжутся от бэкенда,
							починить можно только новым релизом в сторе.
						</div>

						<div className="row">
							<div className="col-md-6 form-group">
								<label><i className="uil-android me-1" />Android (package)</label>
								<input type="text" className="form-control font-monospace fz-13" placeholder="uz.mison.brand"
									value={buildItem.android_package}
									onChange={(e) => setBuildItem({ ...buildItem, 'android_package': e.target.value })} />
							</div>
							<div className="col-md-6 form-group">
								<label><i className="uil-apple me-1" />iOS (bundle id)</label>
								<input type="text" className="form-control font-monospace fz-13" placeholder="uz.mison.brand"
									value={buildItem.ios_bundle_id}
									onChange={(e) => setBuildItem({ ...buildItem, 'ios_bundle_id': e.target.value })} />
							</div>
						</div>

						<div className="row">
							<div className="col-md-6 form-group">
								<label>Ссылка Google Play</label>
								<input type="text" className="form-control fz-13" placeholder="https://play.google.com/store/apps/details?id=..."
									value={buildItem.android_store_url}
									onChange={(e) => setBuildItem({ ...buildItem, 'android_store_url': e.target.value })} />
							</div>
							<div className="col-md-6 form-group">
								<label>Ссылка App Store</label>
								<input type="text" className="form-control fz-13" placeholder="https://apps.apple.com/app/id..."
									value={buildItem.ios_store_url}
									onChange={(e) => setBuildItem({ ...buildItem, 'ios_store_url': e.target.value })} />
							</div>
						</div>

						<p className="text-muted fz-13 mb-2">
							Номера сборок — это <span className="font-monospace">versionCode</span> у Android
							и <span className="font-monospace">CFBundleVersion</span> у iOS. Гость со сборкой ниже
							минимальной не пройдёт дальше экрана обновления, поэтому минимальная не может быть выше последней.
						</p>

						<div className="row">
							<div className="col-md-3 form-group">
								<label>Последняя Android</label>
								<input type="number" min="0" className="form-control"
									value={buildItem.latest_build_android}
									onChange={(e) => setBuildItem({ ...buildItem, 'latest_build_android': e.target.value })} />
							</div>
							<div className="col-md-3 form-group">
								<label>Минимальная Android</label>
								<input type="number" min="0" className="form-control"
									value={buildItem.min_supported_build_android}
									onChange={(e) => setBuildItem({ ...buildItem, 'min_supported_build_android': e.target.value })} />
							</div>
							<div className="col-md-3 form-group">
								<label>Последняя iOS</label>
								<input type="number" min="0" className="form-control"
									value={buildItem.latest_build_ios}
									onChange={(e) => setBuildItem({ ...buildItem, 'latest_build_ios': e.target.value })} />
							</div>
							<div className="col-md-3 form-group">
								<label>Минимальная iOS</label>
								<input type="number" min="0" className="form-control"
									value={buildItem.min_supported_build_ios}
									onChange={(e) => setBuildItem({ ...buildItem, 'min_supported_build_ios': e.target.value })} />
							</div>
						</div>

						<div className="alert alert-light border fz-13 mt-2">
							<div className="fw-semibold mb-1">Демо-вход для проверки в сторах</div>
							Google и Apple требуют рабочий аккаунт, а вход у нас по SMS — проверяющий сидит
							в другой стране, и код до него не дойдёт. На эту пару SMS не отправляется: код
							принимается как есть. Номер берите несуществующий (например <span className="font-monospace">998000000000</span>),
							а после одобрения релиза очистите оба поля — вход закроется.
						</div>

						<div className="row">
							<div className="col-md-6 form-group">
								<label>Телефон демо-входа</label>
								<input type="text" className="form-control font-monospace fz-13" placeholder="998000000000"
									value={buildItem.review_phone}
									onChange={(e) => setBuildItem({ ...buildItem, 'review_phone': e.target.value })} />
							</div>
							<div className="col-md-6 form-group">
								<label>Код демо-входа</label>
								<input type="text" className="form-control font-monospace fz-13" placeholder="000000"
									value={buildItem.review_otp}
									onChange={(e) => setBuildItem({ ...buildItem, 'review_otp': e.target.value })} />
							</div>
						</div>

						{selectedApp?.uuid &&
							<div className="form-group">
								<label>Ссылка на удаление аккаунта (Google Play → Безопасность данных)</label>
								<div className="input-group">
									<input type="text" className="form-control font-monospace fz-13" readOnly
										value={deletionUrl(selectedApp)} />
									<button type="button" className="btn btn-outline-secondary" title="Скопировать"
										onClick={() => copyDeletionUrl(selectedApp)}>
										<i className="uil uil-copy"></i>
									</button>
								</div>
							</div>
						}

						<div className="form-group">
							<label>Статус выпуска</label>
							<select className="form-select"
								value={buildItem.release_status}
								onChange={(e) => setBuildItem({ ...buildItem, 'release_status': Number(e.target.value) })}>
								{Object.entries(RELEASE_STATUSES).map(([value, label]) => (
									<option key={value} value={value}>{label}</option>
								))}
							</select>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100" onClick={() => setBuildModal(false)}>
								Отмена
							</button>
							<button type="submit" className="btn btn-primary w-100">Сохранить</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>

			<Modal show={keyModal} animation={false} centered size="lg" onHide={() => setKeyModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Ключ Firebase — {selectedApp?.brand_name || selectedApp?.login}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={saveKey} autoComplete="off">
						<div className="alert alert-info fz-14">
							Firebase → Настройки проекта → Сервисные аккаунты → «Создать закрытый ключ».
							Нужен именно этот JSON, а не google-services.json приложения.
							Ключ проверяется в Google перед сохранением и хранится зашифрованным.
						</div>

						<div className="form-group">
							<input ref={fileRef} type="file" accept=".json,application/json" className="d-none" onChange={readFile} />
							<button type="button" className="btn btn-outline-primary" onClick={() => fileRef.current?.click()}>
								<i className="uil-upload me-1" />Выбрать файл
							</button>
						</div>

						<div className="form-group">
							<label>Содержимое ключа</label>
							<textarea className="form-control font-monospace fz-12" rows="10"
								placeholder='{"type": "service_account", "project_id": "...", ...}'
								value={credentials}
								onChange={(e) => setCredentials(e.target.value)} />
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100" onClick={() => setKeyModal(false)}>
								Отмена
							</button>
							<button type="submit" className="btn btn-primary w-100">Проверить и сохранить</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>

			<DeleteModal
				modalDelete={deleteModal}
				setModalDelete={setDeleteModal}
				deleteItem={deleteKey}
				message={`Удалить ключ Firebase у «${selectedApp?.brand_name || selectedApp?.login || ''}»? Push гостям этого бренда перестанут уходить.`} />

			<Modal show={testModal} animation={false} centered onHide={() => setTestModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Тестовый push — {selectedApp?.brand_name || selectedApp?.login}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={sendTest} autoComplete="off">
						<p className="text-muted fz-14">
							Гость должен один раз войти в приложение под этим номером и включить уведомления.
						</p>

						<div className="form-group">
							<label>Телефон гостя<span className="required-mark">*</span></label>
							<input type="text" className="form-control" placeholder="998901234567"
								value={testItem.phone}
								onChange={(e) => setTestItem({ ...testItem, 'phone': e.target.value })} />
						</div>
						<div className="form-group">
							<label>Заголовок</label>
							<input type="text" className="form-control" placeholder={selectedApp?.brand_name || ''}
								value={testItem.title}
								onChange={(e) => setTestItem({ ...testItem, 'title': e.target.value })} />
						</div>
						<div className="form-group">
							<label>Текст</label>
							<input type="text" className="form-control" placeholder="Тестовое уведомление: push работает"
								value={testItem.body}
								onChange={(e) => setTestItem({ ...testItem, 'body': e.target.value })} />
						</div>

						{testResult &&
							<div className="border rounded p-2 mb-2 fz-14">
								<div className="fw-semibold mb-1">Доставлено: {testResult.sent} из {testResult.devices.length}</div>
								{testResult.devices.map((device, index) => (
									<div key={index} className={device.success ? 'text-success' : 'text-danger'}>
										{device.platform || 'устройство'}: {device.success
											? 'отправлено'
											: `${device.message || 'ошибка'}${device.dead_token ? ' (токен устарел и удалён)' : ''}`}
										{!device.success && device.details &&
											<div className="text-muted fz-12 text-break">{device.details}</div>
										}
									</div>
								))}
							</div>
						}

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100" onClick={() => setTestModal(false)}>
								Закрыть
							</button>
							<button type="submit" className="btn btn-primary w-100">Отправить</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index
